import { jsPDF } from "jspdf";
import { logoUrl } from "../components/company/LogoPicker";

export const qrUrl = (code) => `${window.location.origin}/f/${code}`;
const canvasFor = (qr) => document.getElementById(`qr-canvas-${qr.id}`);

async function logoDataUrl(company) {
  const url = logoUrl(company);
  if (!url) return null;
  try {
    const blob = await (await fetch(url)).blob();
    return await new Promise((resolve) => { const r = new FileReader(); r.onload = () => resolve(r.result); r.readAsDataURL(blob); });
  } catch (e) {
    return null;
  }
}

export function downloadPng(qr) {
  const a = document.createElement("a");
  a.href = canvasFor(qr).toDataURL("image/png");
  a.download = `qr-${qr.label.replace(/\W+/g, "-").toLowerCase()}.png`;
  a.click();
}

export async function downloadPdf(qr, company) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const logo = await logoDataUrl(company);
  let y = 25;
  if (logo) { doc.addImage(logo, 85, y, 40, 20, undefined, "FAST"); y += 28; }
  doc.setFont("helvetica", "bold"); doc.setFontSize(24); doc.text(company.name, 105, y, { align: "center" }); y += 12;
  doc.setFont("helvetica", "normal"); doc.setFontSize(14);
  const lines = doc.splitTextToSize(qr.message, 160);
  doc.text(lines, 105, y, { align: "center" }); y += lines.length * 7 + 6;
  doc.addImage(canvasFor(qr).toDataURL("image/png"), "PNG", 55, y, 100, 100); y += 110;
  doc.setFontSize(13); doc.text(qr.label, 105, y, { align: "center" }); y += 8;
  doc.setFontSize(9); doc.setTextColor(100); doc.text(qrUrl(qr.code), 105, y, { align: "center" });
  doc.save(`affiche-${qr.label.replace(/\W+/g, "-").toLowerCase()}.pdf`);
}

const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export async function printPoster(qr, company) {
  const w = window.open("", "_blank");
  if (!w) return false;
  const logo = await logoDataUrl(company);
  w.document.write(`<html><head><title>${esc(qr.label)}</title></head><body style="font-family:Arial,sans-serif;text-align:center;padding:50px">
    ${logo ? `<img src="${logo}" style="max-height:90px;max-width:260px;margin-bottom:16px"/>` : ""}
    <h1 style="margin:0 0 12px">${esc(company.name)}</h1><p style="font-size:22px;max-width:620px;margin:0 auto 24px">${esc(qr.message)}</p>
    <img src="${canvasFor(qr).toDataURL("image/png")}" style="width:340px;height:340px"/><p style="font-size:18px">${esc(qr.label)}</p>
    <p style="color:#64748b;font-size:12px">${esc(qrUrl(qr.code))}</p><script>window.onload=()=>window.print()</script></body></html>`);
  w.document.close();
  return true;
}
